export const initialGroupSupOptions = {
  lines: 15,
  background: true,
  bright: 80,
  font: 2,
  border: true,
};
